// Formatos de plata y fecha del panel. Uno solo para todas las tarjetas: si
// una muestra S/14,996 y otra S/ 14996.00, el panel se lee como dos sistemas
// distintos pegados.

export const soles = (v) =>
  `S/ ${Number(v || 0).toLocaleString('es-PE', { maximumFractionDigits: 0 })}`;

export const solesExactos = (v) =>
  `S/ ${Number(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const numero = (v) => Number(v || 0).toLocaleString('es-PE');

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'setiembre', 'octubre', 'noviembre', 'diciembre'];

// Las fechas llegan como 'YYYY-MM-DD'. new Date() con ese formato las lee en
// UTC y en Lima retrocede un dia, asi que se parten a mano.
export const partes = (iso) => {
  const [a, m, d] = String(iso || '').split('-').map(Number);
  return { anio: a, mes: m, dia: d };
};

export const nombreMes = (iso) => MESES[partes(iso).mes - 1] || '';

export const diaYMes = (iso) => {
  const { dia, mes } = partes(iso);
  return `${dia} ${(MESES[mes - 1] || '').slice(0, 3)}`;
};

export const fechaLarga = (iso) => {
  const { dia, mes, anio } = partes(iso);
  return `${dia} de ${MESES[mes - 1]} de ${anio}`;
};

// Capitalize de CSS pone mayuscula en CADA palabra: "5 De Octubre De 2026".
// La mayuscula va solo al principio.
export const conMayuscula = (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1) : '');

/**
 * "vence hoy", "vence mañana", "vence el jue 9". Una fecha suelta obliga a
 * contar los dias con los dedos; esto se entiende de un vistazo.
 */
const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

export const cuandoVence = (iso, hoyIso) => {
  const a = partes(iso);
  const b = partes(hoyIso);
  const fecha = new Date(a.anio, a.mes - 1, a.dia);
  const hoy = new Date(b.anio, b.mes - 1, b.dia);
  const dias = Math.round((fecha - hoy) / 86400000);

  if (dias <= 0) return 'vence hoy';
  if (dias === 1) return 'vence mañana';
  return `vence el ${DIAS[fecha.getDay()]} ${a.dia}`;
};

export const mesAnterior = (iso) => {
  const { mes } = partes(iso);
  return MESES[(mes + 10) % 12];
};
